import LegalPage from "../components/LegalPage";

const TOC = [
  { id: "esenciales", label: "Cookies esenciales" },
  { id: "autenticacion", label: "Cookies de autenticación" },
  { id: "analiticas", label: "Cookies analíticas" },
  { id: "preferencias", label: "Cookies de preferencias" },
  { id: "gestion", label: "Gestionar preferencias" },
];

export default function CookiePolicyPage() {
  return (
    <LegalPage title="Política de Cookies" toc={TOC} testid="cookies-page">
      <p className="legal-lede">
        Esta política explica qué cookies utiliza Mi Contador, para qué sirven y cómo puedes gestionarlas.
      </p>

      <section id="esenciales">
        <h2>1. Cookies esenciales</h2>
        <p>Son necesarias para que la plataforma funcione correctamente. Permiten cargar el sitio, mantener la sesión iniciada y proteger contra abusos. Estas cookies no se pueden desactivar.</p>
      </section>

      <section id="autenticacion">
        <h2>2. Cookies de autenticación</h2>
        <p>Utilizamos cookies para recordar tu sesión de forma segura después de iniciar sesión. Sin ellas tendrías que volver a autenticarte en cada carga.</p>
      </section>

      <section id="analiticas">
        <h2>3. Cookies analíticas</h2>
        <p>Nos ayudan a entender cómo se utiliza la plataforma (páginas visitadas, tiempo de sesión, errores) para mejorar la experiencia. La información se agrega de forma anónima siempre que es posible.</p>
      </section>

      <section id="preferencias">
        <h2>4. Cookies de preferencias</h2>
        <p>Recuerdan tus decisiones (por ejemplo, la empresa activa, filtros o el modo privado del portafolio) para que no tengas que reconfigurarlas cada vez.</p>
      </section>

      <section id="gestion">
        <h2>5. Gestionar preferencias</h2>
        <p>Puedes eliminar las cookies desde la configuración de tu navegador. Ten en cuenta que si bloqueas las cookies esenciales, algunas funciones de Mi Contador dejarán de funcionar.</p>
        <p>Al continuar utilizando la plataforma, aceptas el uso de cookies descrito en esta política.</p>
      </section>
    </LegalPage>
  );
}
